<template style="height: 100%;">
  <el-container>
    <el-header>
      <Header></Header>
    </el-header>

    <Banner></Banner>
    <el-main>
      <!-- 应用客户端 -->
      <el-row>
        <!-- 左侧栏 -->
        <el-col :span="24" id="applicationsyle">
          <div class="leftAPP appsty2">
            <h3>
              <span>应用中心</span>
              <!-- <div class="navleft" style="padding: 5px 0 0 0">
                <a
                  href="javascript:void(0)"
                  v-for="(category, categoryIndex) in clients"
                  :key="category.ClientCategoryId"
                  @click="currentCategoryIndex = categoryIndex"
                  :class="{
                    clientHover: currentCategoryIndex == categoryIndex,
                  }"
                  >{{ category.ClientCategoryName }}</a
                >
              </div> -->
            </h3>

            <div class="leftAPP_1 bgBlueList" :style="{
              display:
                currentCategoryIndex == categoryIndex ? 'block' : 'none',
            }" v-for="(category, categoryIndex) in clients" :key="category.ClientCategoryId">
              <dl v-for="client in category.Clients" :key="client.ClientId">
                <dt>
                  <a :href="client.ClientUri" @click="onClientVisited(client)" target="_blank">
                    <img :src="client.LogoUri" class="client-logo" />
                  </a>
                </dt>
                <dd>
                  <a :title="client.ClientName" :href="client.ClientUri" target="_blank">{{ client.ClientName }}</a>
                </dd>
              </dl>
              <div class="clear"></div>
            </div>
          </div>
        </el-col>
        <!-- 右侧栏 -->
        <!-- <el-col :span="9" id="contentstyle">
          <div class="grid-content bg-purple-light">
            <div style="margin: 0 15px 0 0">
              <div class="indexNoctice">
                <h3>
                  <router-link :to="{ name: 'ArticleList' }" class="more">更多……</router-link>
                  <span>平台公告</span>
                </h3>
                <div class="noticeNew" v-for="item in articles" :key="item.ArticleId">
                  <div class="newNotic1">
                    <dl>
                      <dt>{{ item.PublishTime | date("DD") }}</dt>
                      <dd>{{ item.PublishTime | date("YYYY-MM") }}</dd>
                    </dl>
                    <div class="newNoticMes">
                      <router-link :to="{
                          name: 'ArticleDetail',
                          params: { ArticleId: item.ArticleId },
                        }" target="_blank">{{ item.Title }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row> -->

        <!-- 统计模块 -->

        <!-- <el-row>
        <el-col :span="15">
          <div class="grid-content bg-purple">
            <div class="realtimeTj">
              <h3>
                <span>数据统计</span>
              </h3>
              <div class="realtimeTj-container">
                <dl>
                  <dt>学校</dt>
                  <dd>
                    <div class="yhImg">
                      <img src="/static/index/zhuceImg_03.png"  class="tjimage"/>
                    </div>
                    <span>{{ dataStatistics.SchoolCount }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>教师</dt>
                  <dd>
                    <div class="yhImg">
                      <img src="/static/index/zhuceImg_05.png" class="tjimage"/>
                    </div>
                    <span>{{ dataStatistics.TeacherCount }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>学生</dt>
                  <dd>
                    <div class="yhImg">
                      <img src="/static/index/zhuceImg_11.png" class="tjimage"/>
                    </div>
                    <span>{{ dataStatistics.StudentCount }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>家长</dt>
                  <dd>
                    <div class="yhImg">
                      <img src="/static/index/zhuceImg_08.png" class="tjimage"/>
                    </div>
                    <span>{{ dataStatistics.ParentCount }}</span>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple-light">
            <div class="realtimeTj">
              <h3>
                <span>实时统计</span>
              </h3>
              <div class="realtimeTj-container">
                <dl>
                  <dt>开通应用（项）</dt>
                  <dd>
                    <div class="yyImg">
                      <img src="/static/index/shishiImg_03.png" class="tjimage"/>
                    </div>
                    <span>{{ realtimeStatistics.ClientCount }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>访问次数（次）</dt>
                  <dd>
                    <div class="yyImg">
                      <img src="/static/index/shishiImg_06.png" class="tjimage"/>
                    </div>
                    <span>{{ realtimeStatistics.VisitedCount }}</span>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </el-col> -->
      </el-row>
    </el-main>
    <!-- <el-footer style="height:35px:">
      <Footer></Footer>
    </el-footer> -->
  </el-container>
</template>

<script>
import "./home.scss";
import axios from "../common/axios";
import util from "../common/util";
import { UserManager } from "oidc-client";
import config from "../common/config";
import { GetArticles } from "../api/content/article";
import { GetClients, VisitedClient } from "../api/identity_server/client";
import { GetDataStatistics, GetRealtimeStatistics } from "../api/rpt/rpt";
import Header from "./common/header";
import Footer from "./common/footer";
import Banner from "./common/banner";
export default {
  name: "HelloWorld",
  components: { Header, Banner, Footer },
  data() {
    return {
      articles: [],
      clients: [],
      currentCategoryIndex: 0,
      dataStatistics: {
        SchoolCount: 0,
        TeacherCount: 0,
        ParentCount: 0,
        StudentCount: 0,
      },
      realtimeStatistics: {
        ClientCount: 0,
        VisitedCount: 0,
      },
    };
  },
  methods: {
    onClientVisited: function (client) {
      VisitedClient(client.ClientId);
    },
    getClients: function () {
      GetClients().then((result) => {
        if (result.success) {
          this.clients = result.data || [];
        }
      });
    },
    // getArticles: function () {
    //   let that = this;
    //   GetArticles().then(function (result) {
    //     if (result.success) {
    //       that.articles = result.data || [];
    //     }
    //   });
    // },
    // getDataStatistics: function () {
    //   this.$axios.get("/api/local/SC/RPT/GetDataStatistics").then((result) => {
    //     if (result.success) {
    //       this.dataStatistics = result.data || {};
    //     }
    //   });
    // },
    // getRealtimeStatistics: function () {
    //   this.$axios
    //     .get("/api/local/SC/RPT/GetRealtimeStatistics")
    //     .then((result) => {
    //       if (result.success) {
    //         this.realtimeStatistics = result.data || {};
    //       }
    //     });
    // },
  },
  mounted() {
    var that = this;
    // this.getArticles();
    this.getClients();
    // this.getDataStatistics();
    // this.getRealtimeStatistics();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.el-main {
  top: 0px;
  bottom: 0px;
  position: relative;
  width: 80%;
  background: #fff;
  margin: auto;
  padding: 0px;
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.el-header {
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.el-footer {
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  display: flex;
  position: absolute;
  bottom: 0px;
  right: 0;
  left: 0;
}

.zhcueUser {
  background: #ffffff;
  padding: 20px 0 20px;

  h3 {
    overflow: hidden;
    border-bottom: 1px solid #eaeaea;
    height: 40px;
    line-height: 40px;
    font-size: 16px;

    span {
      color: #333333;
      float: left;
      padding: 0 12px;
      font-size: 22px;
      height: 38px;
      line-height: 38px;
      font-weight: 400;
    }
  }
}

.realtimeTj {
  background: #ffffff;
  padding: 20px 0 20px;

  h3 {
    overflow: hidden;
    border-bottom: 1px solid #eaeaea;
    height: 40px;
    line-height: 40px;
    font-size: 16px;

    span {
      color: #333333;
      float: left;
      padding: 0 12px;
      font-size: 22px;
      height: 38px;
      line-height: 38px;
      font-weight: 400;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/Home.vue